<div
  class="ui segment subtopic-card"
  appMargin="0"
  marginB="2px"
  (click)="viewUsers($event)"
  [ngClass]="{
    'selected-subtopic':
      (isSelected && isActive(subtopic.subtopicId)) ||
      activatedSubtopicId === subtopic.subtopicId
  }"
>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
    <div
      class="subtopic-details-section"
      fxFlex="75"
      fxLayout="column"
      fxLayoutGap="12px"
    >
      <h3 class="ui header subtopic-name">
        {{ subtopic.subtopic }}
      </h3>
      <h3 class="subtopic-date">
        Date Created: {{ subtopic.dateCreated | date: "EEEE d MMMM y" }}
      </h3>
      <p class="subtopic-author">
        Created By: {{ subtopic.createdBy | createdBy }}
      </p>
    </div>

    <div
      class="actions"
      fxFlex="25"
      fxLayout="row"
      fxLayoutGap="20px"
      fxLayoutAlign="space-between center"
    >
      <div class="ui basic primary dropdown" suiDropdown>
        <esl-button
          buttonType="primary"
          buttonSize="medium"
          buttonState="outline"
          buttonActionState="default"
          [hasLine]="true"
          [hasSuffixIcon]="true"
          [buttonMenu]="'dropdownMenu'"
          [hasDropdown]="true"
          [isClickable]="true"
        ></esl-button>
        <div class="left menu actions-dropdown" suiDropdownMenu>
          <div class="item" (click)="onEdit.emit(subtopic)">Edit sub-topic</div>

          <div class="item" (click)="onView.emit(subtopic)">View sub-topic</div>

          <div class="item" (click)="onDelete.emit(subtopic)">
            Delete sub-topic
          </div>

          <div class="item" (click)="onAdd.emit(subtopic)">
            Add user to sub-topic
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
